import Tool, { type ToolArgs } from '../../../tools/Tool';
import { inListOfType } from '../utils';
import ListWrapUtils from '../ListWrapUtils';

// Convert selection to/from a check list.
class ToolCheckList extends Tool {
  static toolName = 'Checkboxes';
  static iconClass = 'fa-regular fa-square-check';

  static action({ editor }: ToolArgs): void {
    if (this.isActive({ editor })) {
      ListWrapUtils.unwrapList(editor);
    } else {
      ListWrapUtils.wrapInList(editor, { type: 'checklist' });
    }
  }

  static isActive({ editor }: ToolArgs): boolean {
    return inListOfType(editor, 'checklist');
  }

  static isEnabled({ controller }: ToolArgs): boolean {
    const tableSelection = controller?.state.pluginState.tableSelection;
    if (!tableSelection) return true;

    return !tableSelection.multipleCellsSelected;
  }
}

export default ToolCheckList;
